export const invalid = (message, values) => {
  if (typeof message === 'string' || typeof message === 'function') {
    return message;
  }
  return { message, values };
};
export const valid = () => undefined;
